// extracted by mini-css-extract-plugin
export default {"container":"FowardButton_container__+9tV0","link":"FowardButton_link__9pyiJ"};